// Module
var code = `<div class="action-group"> <div class="action-group-header"> {{vm.model.Header}} </div> <div class="actions"> <div class="action" ng-repeat="action in vm.model.Actions" ng-click="vm.performAction(action)" ng-if="action.Action != 'ScanCode'"> {{action.Title}} <i class="fa {{action.Icon}}"></i> </div> </div> </div>`;
// Exports
export default code;